const { $, rz, UIkit, dict } = window;

const msg = {};

// SMS form check
msg.validateName = (name) => (Boolean(name.length > 0 && name.length < 32));

msg.validatePhone = (phone) => (Boolean((/^\+?([0-9]{3,4})\)?[-. ]?([0-9]{4})[-. ]?([0-9]{4})$/).test(phone)));

msg.validateText = (text) => (Boolean(text.length <= 512));

msg.sendMessage = async (data) => {
  if (!data || !data.text || !data.phone || !data.name) {
    rz.log({message: "Cant send a message. Missing or incorrect some args", caller: "SSR.sendMessage()", msgtype: "error"});
  }
  const body = {
    message: "Запрос с нашего сайта 'smartteam.dev' from " + data.name + ", phone " + data.phone + ", text: " + data.text,
    includeUserIPandLocation: true,
    messengerType: ["telegram", "mattermost"],
    logins: ["tyagaev.p", "kharitonov", "user-09"] // Тягаев, Харитонов, Нуйкин
  };
  const res = await fetch("/api/sendmessage", {method: "POST", body: JSON.stringify(body), headers: {"Content-Type": "application/json;charset=utf-8", Accept: "application/json"}});
  const ans = await res.json();
  console.log(ans);
  if (ans && ans.err) {
    $("#msg-form").html("---");
    UIkit.notification({ message: ans.err, status: "danger", pos: "bottom-center", timeout: 3000 });
    const isblocked = Boolean(~ans.err.indexOf("blocked") || ~ans.err.indexOf("заблокир"));
    if (isblocked) { window.location.href = "/ban"; return } // Fast redirect
    return rz.log({message: "Cant send message! Server-response:\n" + rz.errToString(ans), caller: "SSR.sendMessage()", msgtype: "error"});
  }
  if (ans.result) {
    UIkit.notification({ message: dict[dict.get()].i.messagesent, status: "secondary", pos: "bottom-center", timeout: 3000 });
    // Clear a form field with message text
    $("#msg-text").val("");
  }
};

// Messages
$("#msg-send").on("click", (e) => {
  e.preventDefault();
  const name = ($("#msg-name").val() || "").trim(), phone = ($("#msg-phone").val() || "").trim(), text = ($("#msg-text").val() || "").trim();
  let validationFields = true;
  if (!msg.validateName(name)) { $("#sms-name").addClass("uk-form-danger").removeClass("uk-form-success"); validationFields = false }
  if (!msg.validatePhone(phone)) { $("#sms-phone").addClass("uk-form-danger").removeClass("uk-form-success"); validationFields = false }
  if (!msg.validateText(text)) { $("#sms-text").addClass("uk-form-danger").removeClass("uk-form-success"); validationFields = false }
  if (validationFields) { msg.sendMessage({name, phone, text}) }
  else {
    UIkit.notification({ message: dict[dict.get()].e.incorrentfields, status: "danger", pos: "bottom-center", timeout: 3000 });
  }
});
$("#msg-name").on("keyup", (e) => {
  const name = $(e.target).val().trim();
  if (msg.validateName(name)) { $(e.target).removeClass("uk-form-danger").addClass("uk-form-success") }
  else { $(e.target).removeClass("uk-form-success").addClass("uk-form-danger") }
});
$("#msg-phone").on("keyup", (e) => {
  const phone = $(e.target).val().trim();
  if (msg.validatePhone(phone)) { $(e.target).removeClass("uk-form-danger").addClass("uk-form-success") }
  else { $(e.target).removeClass("uk-form-success").addClass("uk-form-danger") }
});
$("#msg-text").on("keyup", (e) => {
  const text = $(e.target).val().trim();
  if (msg.validateText(text)) { $(e.target).removeClass("uk-form-danger").addClass("uk-form-success") }
  else { $(e.target).removeClass("uk-form-success").addClass("uk-form-danger") }
});

export default msg;
